// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgExpandedProfileTappy: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <circle
        cx={12}
        cy={12}
        r={12}
        fill={secondary ?? fill ?? '#fff'}
        transform="matrix(1 0 0 -1 0 24)"
      />
      <path
        fill={primary ?? fill ?? '#000'}
        fillRule="evenodd"
        d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m-.827 6.401-1.145 1.34-2.787 3.293c-.458.528-.242.97.47.97h2.215c.05.359.156 1.165.267 2.01.14 1.067.287 2.196.344 2.573.015.37.175.72.446.982s.634.416 1.017.431a1.553 1.553 0 0 0 1.018-.43 1.45 1.45 0 0 0 .446-.983c.056-.377.204-1.506.344-2.572.11-.846.216-1.652.267-2.01h2.201c.726 0 .942-.443.484-.972l-1.133-1.339-1.667-1.953-1.133-1.34a1.024 1.024 0 0 0-.364-.295 1.061 1.061 0 0 0-.926 0c-.143.07-.268.17-.364.295"
        clipRule="evenodd"
      />
    </svg>
  );
};

const Memo = memo(SvgExpandedProfileTappy);
export default Memo;
